/**
 * Where a Run / Queue click goes (2026-09-08 evening, owner's model).
 *
 *   "queue"  Run                → POST /rsa/v2/queue; the controller admits it
 *                                 automatically when capacity allows.
 *   "hold"   Queue (admin only) → the SAME POST with {"hold": true}: the entry is
 *                                 stored HELD and never admitted until an admin
 *                                 starts it from the Multi-project runs view.
 *   "now"    direct /process?engine=v2 → only for run types the queue does not
 *                                 admit (rsa-model, queueRunEnabled=false); no UI
 *                                 button offers it for rsa-existing.
 *
 * Nothing navigates away after a click any more ("Queue with priority…" and its
 * jump to the queue view are gone). Pure so the two call sites (handleSubmit,
 * runSelectedRoutes) and the tests share one decision; the payload itself is
 * built elsewhere and is identical for every mode — `hold` is the only addition.
 */
export const RUN_MODE_QUEUE = "queue";
export const RUN_MODE_HOLD = "hold";
export const RUN_MODE_NOW = "now";

export const RUN_TITLE =
  "Adds this run to the queue; it starts automatically as soon as capacity allows";

export const QUEUE_HOLD_TITLE =
  "Adds this analysis to the multi-project queue without starting it. Start it from Multi-project runs.";

export const resolveRunDispatch = ({
  mode = RUN_MODE_QUEUE,
  queueRunEnabled = true,
  processApi,
  baseProcessUrl,
} = {}) => {
  const queued = Boolean(queueRunEnabled) && mode !== RUN_MODE_NOW;
  return {
    runMode: queued ? RUN_MODE_QUEUE : RUN_MODE_NOW,
    url: queued ? `${processApi}/rsa/v2/queue` : `${baseProcessUrl}?engine=v2`,
    hold: queued && mode === RUN_MODE_HOLD,
  };
};

/** The body to POST for a resolved dispatch: the payload, plus `hold: true` for "Queue". */
export const dispatchBody = (payload, plan) =>
  plan?.hold ? { ...payload, hold: true } : payload;
